import { Environment, Environments } from './config'
import { FlagConfigs } from './flags/flags'

// This is defunct, but not being removed for now (See CSSEditor component
const allowCSSFramework: string[] = []

// People who should be able to at least see every piece of functionality.
// Either devs that work with the full stack or management that needs to know the full state of the product
// at any given time.
const allowAll = [
  'crivera@powerchordsystem.com',
  'dhartwell@powerchordsystem.com',
  'bbartlett@powerchordsystem.com',
  'jhillegas@powerchordsystem.com',
  'jbutler@powerchordsystem.com',
]

// Same as allowAll but only for non-production environments - mostly Team Blue devs.
// This basically just limits visibility to Default Rules, since we don't want them accidentally edited.
const allowAllNonProd = [
  ...allowAll,
  'jmostyn@powerchordsystem.com',
  'tmctesterson@powerchordsystem.com',
  // Team Orange QA, occasionally needs access to help out
  'esibal@powerchordsystem.com',
]

// People who need elevated access to view Architect and pages within
const allowArchitect = [
  ...allowAllNonProd,
  'bdundas@powerchordsystem.com',
  'kcline@powerchordsystem.com',
  'vraykovitz@powerchordsystem.com',
  'bsawhill@powerchordsystem.com',
  'dwoodruff@powerchordsystem.com',
]

const internalDomains = ['powerchord.com', 'powerchord.io', 'powerchordsystem.com']

const flags: FlagConfigs = {
  architect: {
    users: allowArchitect,
  },
  internal: {
    domains: internalDomains,
  },
  cssFramework: {
    users: allowCSSFramework,
  },
  localeSwitcher: {
    environments: Environments,
  },
  languageToggle: {
    environments: Environments,
  },
  ruleAdmins: {
    users: allowAll,
  },
  ruleDevs: {
    users: allowAllNonProd,
    environments: Environments.filter((env) => env !== Environment.Production),
  },
}

export default flags
